import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalFormat',
    standalone: true
})
export class DecimalFormatPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (typeof value !== 'string') {
      value = value.toString();
    }
    return value ? value.replace('.', ',') : '';
  }
}
